import React, {useState} from 'react';

import './styles.scss';
import {Column, Row} from '../layout';
import {useHistory} from 'react-router-dom';
import * as fonts from '../../util/fonts';
import {createGUID} from '../../util/utility';
import AppUserLogout from '../app-userlogout';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import {compose} from 'redux';
import {connect} from 'react-redux';
import AppLanguageSelector from '../app-language-selector';
import {strings} from '../../util/strings';
import {ITenant} from '../../App';
import AuthorizedImage from '../images';
import ArrowIcon from '../../containers/medical-network/ArrowIcon';

interface menuItemSub {
  label: string;
  selector: string;
  url: string;
}

interface menuItem {
  label: string;
  selector: string;
  url: string;
  subItems?: menuItemSub[];
}

interface AppNavResponsiveProps {
  items: menuItem[];
  onClose(): void;
  busFuncMap: any;
  selectedBu: any;
  buStyles: any;
  user: any;
  labels: typeof strings.pt.menu;
  tenant: ITenant;
}

function AppNavResponsive({
  items,
  onClose,
  busFuncMap,
  selectedBu,
  buStyles,
  user,
  labels,
  tenant,
}: AppNavResponsiveProps) {
  const history = useHistory();

  const [showDropdownItem, setShowDropdownItem] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);

  const handleSelectedItem = (item: menuItem) => {
    setSelectedItem(item.selector);
  };

  const handleDropdownShow = () => {
    if (showDropdownItem) {
      setShowDropdownItem(false);
      setSelectedItem('');
    } else {
      setShowDropdownItem(true);
    }
  };

  const renderMenuItem = (item: menuItem) => {
    return (
      <Column key={createGUID()}>
        {item.url === '' ? (
          <Row
            onClick={() => {
              handleSelectedItem(item);
              handleDropdownShow();
            }}>
            <Column
              className="app-nav-menu-label"
              key={item.label}
              style={{
                ...fonts.L,
                ...fonts.Bold,
                color: buStyles?.primaryColor || colors.fluorescentBlue,
              }}>
              {item.label}
            </Column>
            {showDropdownItem && selectedItem == item.selector ? (
              <Column className="logout-user-column-dropdown dropdown-inner">
                <Icon
                  className="logout-user-input-icon-dropdown"
                  color={buStyles?.primaryColor || colors.fluorescentBlue}
                  name={Icons.CHEVRON_DOWN}
                  width={'22'}
                  height={'22'}
                  strokeWidth={'1'}
                />
              </Column>
            ) : (
              <Column className="logout-user-column-dropdown dropdown-inner">
                <Icon
                  className="logout-user-input-icon"
                  color={buStyles?.primaryColor || colors.fluorescentBlue}
                  name={Icons.CHEVRON_DOWN}
                  width={'22'}
                  height={'22'}
                  strokeWidth={'1'}
                />
              </Column>
            )}
          </Row>
        ) : (
          <Row
            className="app-nav-menu-label"
            key={item.label}
            onClick={() => {
              handleSelectedItem(item);
              history.push(item.url);
              setShowDropdownItem(false);
              onClose();
            }}
            style={{
              ...fonts.L,
              ...fonts.Bold,
              color: buStyles?.primaryColor || colors.fluorescentBlue,
            }}>
            {item.label}
          </Row>
        )}

        {selectedItem == item.selector && (
          <div className="app-nav-menu-dropdown">
            {item.subItems?.map((subItem) =>
              busFuncMap
                ? busFuncMap[selectedBu]?.map((func: any) => {
                    if (
                      func?.isVisible &&
                      subItem.selector === func?.featureTemplateAlias
                    ) {
                      return (
                        <div key={createGUID()}>
                          {showDropdownItem && (
                            <div
                              key={subItem.label}
                              className="app-nav-menu-sub-item"
                              onClick={() => {
                                history.push(subItem.url);
                                onClose();
                              }}
                              style={{
                                ...fonts.ML,
                                ...fonts.SemiBold,
                                color:
                                  buStyles?.primaryColor ||
                                  colors.fluorescentBlue,
                              }}>
                              {subItem.label}
                            </div>
                          )}
                        </div>
                      );
                    }
                  })
                : null
            )}
          </div>
        )}
      </Column>
    );
  };

  const hasAtLeastOneChildActive = (item: any) => {
    const subItemsSelectors = item.subItems.map(
      (subItem: any) => subItem.selector
    );
    return busFuncMap[selectedBu].some((buFunc: any) =>
      subItemsSelectors.includes(buFunc.featureTemplateAlias)
    );
  };

  return (
    <div className="app-nav-responsive">
      <AuthorizedImage
        requiresAuthorization={false}
        source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC}${
          tenant?.footerImage || buStyles?.logo
        }`}
        alt="ADVLogo"
        width="210"
        height="72"
        className="app-header-logo app-header-logo-responsive"
      />
      <Icon
        className="responsive-menu-button close-button svg-close-button"
        width="26"
        height="26"
        name={Icons.CLOSE}
        onClick={() => onClose()}
      />
      <AppUserLogout setShowLanguageSelector={setShowLanguageSelector} />
      <div className="app-nav-menu-row-container">
        <Row className="app-nav-menu-row">
          {items?.map((item) =>
            busFuncMap
              ? busFuncMap[selectedBu]?.map((func: any) => {
                  if (
                    func?.isVisible &&
                    item.selector === func?.featureTemplateAlias &&
                    !item.subItems
                  ) {
                    return renderMenuItem(item);
                  } else if (
                    func?.isVisible &&
                    item.selector === func?.featureTemplateAlias &&
                    item.subItems &&
                    item.subItems.length > 0 &&
                    hasAtLeastOneChildActive(item)
                  ) {
                    return renderMenuItem(item);
                  }
                })
              : null
          )}
        </Row>
      </div>
      {user.state === 'CLIENT' && (
        <AppLanguageSelector
          show={showLanguageSelector}
          setShow={setShowLanguageSelector}
        />
      )}
    </div>
  );
}

const mapStateToProps = ({globalStyles, user, strings, tenant}: any) => ({
  buStyles: globalStyles.value,
  user: user.value,
  labels: strings.value.pt.menu,
  tenant: tenant.value,
});

export default compose(connect(mapStateToProps)(AppNavResponsive));
